export default __webpack_public_path__ + "static/media/instagram.906e1d20.svg";